import { gql, useMutation } from '@apollo/client';

// Mutations de curtida centralizadas
export const CRIAR_CURTIDA = gql`
    mutation CriarCurtida($input: CurtidaInput!) {
        criarCurtida(input: $input) {
            id
        }
    }
`;

export const REMOVER_CURTIDA = gql`
    mutation RemoverCurtida(
        $autorAtletaId: ID
        $autorTorneioId: ID
        $comentarioId: ID!
        $postId: ID!
        $autorLigaId: ID
    ) {
        removerCurtida(
            autorAtletaId: $autorAtletaId
            autorTorneioId: $autorTorneioId
            comentarioId: $comentarioId
            postId: $postId
            autorLigaId: $autorLigaId
        )
    }
`;

// Hooks helpers
export function useCriarCurtida() {
  return useMutation(CRIAR_CURTIDA);
}

export function useRemoverCurtida() {
  return useMutation(REMOVER_CURTIDA);
}

